export const MAINNET_REALITY_ADDRESSES = [
    "0xce9b84c5612beaa234ad0d9fa7d283293479510e", //WeTrust
    "0xd47f72a2d1d0e91b0ec5e5f5d02b2dc26d00a14d", //Ethereum main (old)
    "0x728cba71a3723caab33ea416cb46e2cc9215a596", //Ethereum main (deprecated)
    "0xFf32eff53459485074b4Db14633252C9dcA3791A", //Ethereum main (new)
    "0xf72cfd1b34a91a64f9a98537fe63fbab7530adca", //Ethereum DAO Governance
    "0x2018038203aEE8e7a29dABd73771b0355D4F85ad", //Ethereum Seer
    "0xc45d8d9b2b6843528a4dc2d8b5858e5c258d2992", //Ethereum Seer new (idle)
    "0x1c2811550551d84030cd1b608e6fe3fd6fd5fc0d", //Lockler
].map((address) => address.toLowerCase());

export const GNOSIS_REALITY_ADDRESSES = [
    "0x2f0895732bfacdcf2fdb19962fe609d0da695f21", //Gnosis-Ethereum main Foreign Proxy (deprecated)
    "0x5AFa42b30955f137e10f89dfb5EF1542a186F90e", //Gnosis-Ethereum Polkamarkets Foreland Home Proxy
    "0x8453bA2C9eA5Bae36fDe6cBd61c12c05b6552425", //Gnosis-Ethereum Polkamarkets Foreland Foreign Proxy
    "0x68154EA682f95BF582b80Dd6453FA401737491Dc", //Gnosis-Ethereum Seer Home Proxy
    "0xFe0eb5fC686f929Eb26D541D75Bb59F816c0Aa68", //Gnosis-Ethereum Seer Foreign Proxy
    "0xe04f5791d671d5c4e08ab49b39807087b591ea3e", //Moderate / Susie
    "0x5562ac605764dc4039fb6ab56a74f7321396cdf2", //Gnosis-Ethereum Omen AI with appeals Home Proxy
    "0xeF2Ae6961Ec7F2105bc2693Bc32fA7b7386B2f59", //Gnosis-Ethereum Omen AI with appeals Foreign Proxy
    "0x88Fb25D399310c07d35cB9091b8346d8b1893aa5", //Gnosis-Ethereum RealitioHomeArbitrationProxy (no identification)
    "0x32bcDC9776692679CfBBf8350BAd67Da13FaaA3F", //Gnosis-Ethereum RealitioForeignArbitrationProxyWithAppeals (no identification)
].map((address) => address.toLowerCase());

export const POLYGON_REALITY_ADDRESSES = [
    "0x5AFa42b30955f137e10f89dfb5EF1542a186F90e", //Polygon-Ethereum Home Proxy
    "0x776e5853e3d61b2dfb22bcf872a43bf9a1231e52", //Polygon-Ethereum Foreign Proxy
    "0x68154ea682f95bf582b80dd6453fa401737491dc", //Polygon-Ethereum Polkamarkets Home Proxy
    "0x68c4cc21378301cfdd5702d66d58a036d7bafe28", //Polygon-Ethereum Polkamarkets Foreign Proxy
    "0xb4Fc64C6FfE0B04EA1EC9bf27fB2e8696C82B2eF", //Polygon-Ethereum SUKU Home Proxy
    "0xd6bF90e1daaA5CDEc82235d2db1B93a9d50C6046", //Polygon-Ethereum SUKU Foreign Proxy
].map((address) => address.toLowerCase());

export const SEPOLIA_REALITY_ADDRESSES = [
    "0x05B942fAEcfB3924970E3A28e0F230910CEDFF45", //Sepolia
].map((address) => address.toLowerCase());

export const ZKSYNC_SEPOLIA_REALITY_ADDRESSES = [
    "0x473DC4158bEA5eB9a72b6e51Fa5668CE6A41530D", //zkSepolia-Sepolia Home Proxy
    "0x54C68fa979883d317C10F3cfDdc33522889d5612", //zkSepolia-Sepolia Foreign Proxy
].map((address) => address.toLowerCase());

export const GNOSIS_CHIADO_REALITY_ADDRESSES = [
    "0x7a547214a0Ab7EfD835670Eda696Dda1b6603805", //Chiado
    "0xE620947519E8102aa625BBB4669fE317c9FffeD7", //GnosisChiado-Sepolia Home Proxy
    "0x5d7cB72B31C080CF2de5f57fd38DedBeaf969D42", //GnosisChiado-Sepolia Foreign Proxy
    "0x867c848b8Cb3fc60c06820C44084a271f8197c89", //GnosisChiado-Sepolia RealitioHomeArbitrationProxy (no identification)
    "0x252e210B33083E9dFB9d94C526767B83Be579d8b", //GnosisChiado-Sepolia RealitioForeignArbitrationProxyWithAppeals (no identification)
].map((address) => address.toLowerCase());

export const OPTIMISM_SEPOLIA_REALITY_ADDRESSES = [
    "0xFe0eb5fC686f929Eb26D541D75Bb59F816c0Aa68", //OptimismSepolia-Sepolia Home Proxy
    "0x6a41AF8FC7f68bdd13B2c7D50824Ed49155DC3bA", //OptimismSepolia-Sepolia Foreign Proxy
].map((address) => address.toLowerCase());

export const BASE_REALITY_ADDRESSES = [
    "0xd04f24364687dbd6db67d2101fae59e91a6e605b", //Base-Ethereum Home Proxy
    "0xF0b37Feda6CDF5F78B37e1Fbccc24969059F2044", //Base-Ethereum Foreign Proxy
].map((address) => address.toLowerCase());

export const BASE_SEPOLIA_REALITY_ADDRESSES = [
    "0xd919c6Edfb458C15c12b921Cbc9F6eEf06F0E9c5", //BaseSepolia-Sepolia RealitioHomeProxyBaseSepolia (no identification)
    "0x7331A1512DBe2d77bc19e8D2b923fD76214c0F77", //BaseSepolia-Sepolia RealitioForeignProxyBaseSepoila (no identification)
].map((address) => address.toLowerCase());

export const UNICHAIN_REALITY_ADDRESSES = [
    "0x8FeAB350A304140b1593A38a13607d122BEC44b6", //Unichain-Ethereum RealitioHomeProxyUnichain (no identification)
    "0x3FB8314C628E9afE7677946D3E23443Ce748Ac17", //Unichain-Ethereum RealitioForeignProxyUnichain (no identification)
].map((address) => address.toLowerCase());

export const UNICHAIN_SEPOLIA_REALITY_ADDRESSES = [
    "0x05295972F75cFeE7fE66E6BDDC0435c9Fd083D18", //UnichainSepolia-Sepolia RealitioHomeProxyUnichainSepolia (no identification)
    "0xC10D916467aDdC02464aC98036E58644F0E50311", //UnichainSepolia-Sepolia RealitioForeignProxyUnichainSepolia (no identification)
].map((address) => address.toLowerCase());
